import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://localhost:5001/clone-80344/us-central1/api' // The API url
});

export default instance;